import _ from 'lodash';
import oboe from 'oboe';
import moment from 'moment';

import * as BECaller from '../util/apiCaller';

// serialize Date and Moment instances to timestamp
function ts(date) {
  if (!date) return undefined;
  if (typeof date === 'number') return date;
  else if (typeof date === 'string') return +new Date(date);
  else if (typeof date.valueOf === 'function') return date.valueOf();
  else if (typeof date.toString === 'function') return date.toString();
  else return undefined;
}

function updateLastAccessed(dashboardId) {
  return new Promise((resolve, reject) => {
    BECaller.api(`dashboards/${dashboardId}/lastaccessed`, 'PUT').then(
      () => {
        resolve();
      },
      err => {
        reject(err);
      }
    );
  });
}

function getActivities(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let activities = [];
    BECaller.stream(`streams/activities?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.endDate)}`)
      .node('{cardId}', node => {
        activities.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(activities);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getBlockedActivities(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let activities = [];
    BECaller.stream(`streams/blocked?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.endDate)}`)
      .node('{cardId}', node => {
        activities.push(JSON.parse(JSON.stringify(node)));
      })
      .done(() => {
        resolve(activities);
        return oboe.drop;
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getCfActivities(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let activities = [];
    BECaller.stream(`streams/cfactivities?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.startDate)}`)
      .node('{cardId}', node => {
        activities.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(activities);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getCards(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let cards = [];
    BECaller.stream(`streams/cards?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.startDate)}`)
      .node('{name}', node => {
        cards.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(cards);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getLists(dashboardId) {
  return new Promise((resolve, reject) => {
    let lists = [];
    BECaller.stream(`streams/lists?board=${dashboardId}`)
      .node('{_id}', node => {
        lists.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(lists);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getLabels(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let labels = [];
    BECaller.stream(`streams/labels?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.startDate)}`)
      .node('{_id}', node => {
        labels.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(labels);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getMembers(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let members = [];
    BECaller.stream(`streams/members?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.startDate)}`)
      .node('{_id}', node => {
        members.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(members);
      })
      .fail(err => {
        reject(err);
      });
  });
}

function getCustomFields(dashboardId, dates) {
  return new Promise((resolve, reject) => {
    let customfields = [];
    BECaller.stream(`streams/customfields?board=${dashboardId}&startDate=${ts(dates.startDate)}&endDate=${ts(dates.startDate)}`)
      .node('{name}', node => {
        customfields.push(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      })
      .done(() => {
        resolve(_.filter(customfields, cf => !!cf.options.length));
      })
      .fail(err => {
        reject(err);
      });
  });
}

function checkPullingState(dashboardId) {
  return new Promise((resolve, reject) => {
    BECaller.api(`dashboards/${dashboardId}/pullingstatus`, 'get').then(
      node => {
        resolve(JSON.parse(JSON.stringify(node)));
        return oboe.drop;
      },
      err => {
        reject(err);
      }
    );
  });
}

function getAnalysisDates(dashboardId) {
  return new Promise((resolve, reject) => {
    BECaller.api(`dashboards/${dashboardId}/analysisDates`, 'get').then(
        (dates) => {
          dates.startDate = moment(dates.startDate);
          dates.endDate = moment(dates.endDate);
          resolve(dates);
        },
        (err) => {
          reject(err);
        }
      );  
  });
}

export default {
  updateLastAccessed,
  getActivities,
  getBlockedActivities,
  getCfActivities,
  getLists,
  getCards,
  getLabels,
  getMembers,
  getCustomFields,
  checkPullingState,
  getAnalysisDates
};
